import { useEffect } from 'react';
import { Box, HStack, Input, Text, useColorMode } from '@chakra-ui/react';
import { ToolbarProps } from 'react-big-calendar';

import { useCalendarSettings, useIconColor } from '../../../lib';
import { FiltersDrawer } from './FiltersDrawer';
import { formatNavigation, ViewMenu } from '.';
import { ChevronLeft, ChevronRight } from '../../icons';
import { useToolbarLogic } from './useToolbarLogic';

export const DesktopToolbar = ({
	date,
	view,
	views,
	onNavigate,
	onView,
	setCurrentMonth,
}: ToolbarProps & { setCurrentMonth: React.Dispatch<React.SetStateAction<string>> }) => {
	const { colorMode } = useColorMode();
	const {
		inputValue,
		inputType,
		handlePrevClick,
		handleNextClick,
		handleTodayClick,
		handleDateInputChange,
		createViewChangeHandler,
		viewLabels,
	} = useToolbarLogic(date, view, onNavigate, onView);

	const iconColor = useIconColor();
	const { settings } = useCalendarSettings();

	useEffect(() => {
		setCurrentMonth(inputValue);
	}, [inputValue, setCurrentMonth]);

	const { calendarToolbarBackgroundColor, calendarTextColor } = settings.styles[colorMode];
	const { todayText } = formatNavigation(date, view);
	return (
		<HStack
			borderRadius={settings.radius.toolbar}
			spacing={4}
			p={4}
			gap={2}
			bg={settings.styles[colorMode]?.calendarToolbarBackgroundColor || 'white'}
			justify='space-between'
			align='center'
			className='calendar-toolbar'
		>
			<HStack w='full' alignItems='center' justifyContent='flex-start' px={1} py={2}>
				<Box onClick={handlePrevClick} cursor='pointer'>
					<ChevronLeft size={18} fill={iconColor} style={{ margin: '0px' }} />
				</Box>
				<Box onClick={handleNextClick} cursor='pointer'>
					<ChevronRight size={18} fill={iconColor} style={{ margin: '0px' }} />
				</Box>
				<Text onClick={handleTodayClick} cursor='pointer' paddingInline={4}>
					{todayText}
				</Text>
				<Input
					backgroundColor={`${calendarToolbarBackgroundColor} !important`}
					color={`${calendarTextColor} !important`}
					borderColor={`${settings.styles[colorMode]?.calendarBordersColor || 'black'} !important`}
					maxW='300px'
					placeholder='Select Date'
					size='md'
					type={inputType}
					value={inputValue}
					onChange={handleDateInputChange}
					css={{
						'&::-webkit-calendar-picker-indicator': {
							filter: `invert(${colorMode === 'light' ? 0 : 1})`,
						},
					}}
				/>
			</HStack>
			<HStack>
				<FiltersDrawer border={false} />
			</HStack>
			<ViewMenu
				isDesktop={true}
				views={views}
				createViewChangeHandler={createViewChangeHandler}
				viewLabels={viewLabels}
			/>
		</HStack>
	);
};
